// extracted by mini-css-extract-plugin
module.exports = {"privacy":"privacy_privacy__3tiy3","body":"privacy_body__2OSZ_"};